<template>
  <a-form
    :form="form.fc">
    <p>{{$t('common_482')}}</p>
    <a-form-item :label="$t('scope.text_932')" v-bind="formItemLayout">
      <base-select
        class="w-100"
        v-decorator="decorators.gcp_billing_id"
        filterable
        id-key="gcp_billingaccount_id"
        name-key="gcp_billingaccount_name"
        :options="billingActions"
        :labelFormat="labelFormat"
        :select-props="{ placeholder: $t('common_483') }"
        :item.sync="gcpBillingOpt" />
    </a-form-item>
    <a-form-item :label="$t('scope.text_542')" v-bind="formItemLayout" required>
      <div class="d-flex" v-for="item in discountInfos" :key="item.key">
        <discount-info :decorator="genDecorator(item.key)" />
        <a-button v-if="discountInfos.length > 1" shape="circle" icon="minus" size="small" @click="deCrease(item.key)" class="mt-2 ml-2" />
      </div>
      <div class="d-flex align-items-center">
        <a-button type="primary" shape="circle" icon="plus" size="small" @click="addDiscount" />
        <a-button type="link" @click="addDiscount">{{$t('common_114')}}</a-button>
      </div>
    </a-form-item>
    <a-divider />
    <p>{{$t('common_484')}}</p>
    <a-form-item :label="$t('common_485')" v-bind="formItemLayout">
      <a-input-number
      v-decorator="decorators.huawei_deposit"
      :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
      :parser="value => value.replace(/\￥\s?|(,*)/g, '')" />
    </a-form-item>
  </a-form>
</template>

<script>
import * as R from 'ramda'
import { mapGetters } from 'vuex'
import DiscountInfo from '../components/DiscountInfo'
import { uuid } from '@/utils/utils'

export default {
  name: 'CloudAccountInitSetting',
  components: {
    DiscountInfo,
  },
  props: {
    customerId: String,
  },
  data () {
    return {
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 19,
        },
        labelCol: {
          span: 5,
        },
      },
      decorators: {
        gcp_billing_id: [
          'gcp_billing_id',
          {
            rules: [
              { required: true, message: this.$t('common_483') },
            ],
          },
        ],
        huawei_deposit: [
          'huawei_deposit',
          {
            rules: [
              { required: true, message: this.$t('common_486') },
            ],
          },
        ],
        discountInfo: {
          resource_type: i => [
            `resource_type[${i}]`,
            {
              rules: [
                { required: true, message: this.$t('scope.text_507') },
              ],
            },
          ],
          price: i => [
            `price[${i}]`,
            {
              rules: [
                { required: true, message: this.$t('scope.text_513') },
              ],
            },
          ],
        },
      },
      discountInfos: [{
        key: uuid(),
      }],
      billingActions: [],
      gcpBillingOpt: {},
      initValue: {},
    }
  },
  computed: {
    ...mapGetters(['scope']),
  },
  async created () {
    const { data } = await this.fetchBillingAccounts()
    const { data: res } = await this.fetchCustomerMetadata()
    this.billingActions = data
    if (!R.isEmpty(res)) {
      const val = JSON.parse(res.__billing_profile__)
      const { gcp_billing_id, gcp_cloudsupplier_id, huawei_deposit, gcp_discounts } = val
      this.initValue = {
        gcp_billing_id,
        gcp_cloudsupplier_id,
        huawei_deposit,
        gcp_discounts: {},
      }
      this.discountInfos = []
      if (gcp_discounts) {
        gcp_discounts.map(item => {
          const id = uuid()
          this.initValue.gcp_discounts[id] = item
          this.discountInfos.push({
            key: id,
          })
          this.form.fc.getFieldDecorator(`resource_type[${id}]`, { initialValue: this.initValue.gcp_discounts[id].resource_type, preserve: true })
          this.form.fc.getFieldDecorator(`price[${id}]`, {
            initialValue: this.initValue.gcp_discounts[id].price_type === 'percent' ? this.initValue.gcp_discounts[id].price * 100 : Number(this.initValue.gcp_discounts[id].price),
            preserve: true,
          })
        })
      }
      this.gcpBillingOpt.cloudsupplier_id = val.gcp_cloudsupplier_id
      this.form.fc.getFieldDecorator('gcp_billing_id', { initialValue: val.gcp_billing_id, preserve: true })
      this.form.fc.getFieldDecorator('huawei_deposit', { initialValue: val.huawei_deposit, preserve: true })
    }
  },
  methods: {
    labelFormat (item) {
      return `${item.gcp_billingaccount_name}(${item.gcp_billingaccount_id})`
    },
    genDecorator (uid) {
      const ret = {}
      R.forEachObjIndexed((item, key) => {
        ret[key] = item(uid)
      }, this.decorators.discountInfo)
      return ret
    },
    addDiscount () {
      const key = uuid()
      const discountInfo = {
        key,
      }
      this.discountInfos.push(discountInfo)
    },
    deCrease (key) {
      const index = this.discountInfos.findIndex(val => val.key === key)
      this.discountInfos.splice(index, 1)
    },
    fetchBillingAccounts () {
      return new this.$Manager('customers').getSpecific({
        id: this.customerId,
        spec: 'gcp-billingaccounts',
      })
    },
    fetchCustomerMetadata () {
      return new this.$Manager('customers').getSpecific({
        id: this.customerId,
        spec: 'metadata',
      })
    },
    doUpdate (data) {
      return this.params.onManager('performAction', {
        id: this.customerId,
        managerArgs: {
          action: 'billing-profile',
          data,
        },
      })
    },
    genValues (values) {
      const { gcp_billing_id, huawei_deposit, price, resource_type } = values
      const ret = {
        gcp_billing_id,
        gcp_cloudsupplier_id: this.gcpBillingOpt.cloudsupplier_id,
        huawei_deposit,
        gcp_discounts: [],
      }
      R.forEachObjIndexed((item, key) => {
        const obj = {
          price: resource_type[key] === 'cdn' ? Number(item) : item / 100,
          price_type: resource_type[key] === 'cdn' ? 'amount' : 'percent',
          resource_type: resource_type[key],
        }
        ret.gcp_discounts.push(obj)
      }, price)
      return ret
    },
    async getValues () {
      const values = await this.form.fc.validateFields()
      const data = this.genValues(values)
      return data
    },
  },
}
</script>
